import illustrationOnboarding from "./Central Hero Illustration.png";
import illustrationCogwheel from "./cogwheel.svg";
import illustrationManualInfraction from "./file-search-02.svg";

export const IMAGES = {
	IllustrationOnboarding: illustrationOnboarding,
	IllustrationManualInfraction: illustrationManualInfraction,
	IllustrationCogwheel: illustrationCogwheel,
} as const;
